import generalConfig from 'services/metaData/generalConfig';
import http from 'services/utils/http';

export const apiPath = `${generalConfig().sspPlatformJsDomain}/api/v1/partners/cvManager`;
export const apiKey = 'cvManager';
export const getDataForIdAPIPath = (id) => `${apiPath}/${id}`;
export const MIN_STEP_JUMP = 0.5;
export const CENT_SYMBOL = '¢';
export const saveCVMap = ({
    id,
    apps,
    enableSDKSetCV,
    name,
    steps
}) => {
    const method = id === 'new' ? 'post' : 'put';
    const path = id === 'new' ? apiPath : `${apiPath}/${id}`;
    const data = {
        apps,
        name,
        enableSDKSetCV,
        steps
    };
    return http[method](path, data);
};

// eslint-disable-next-line eqeqeq
export const formatSteps = (steps) => steps.map((step) => ({ key: step?.key, max: step?.max }));
export const statsApiPath = `${generalConfig().sspPlatformJsDomain}/api/v1/partners/CvManagerStats`;
export const statsApiKey = 'cvManagerStats';
export const getStats = ({
    apps,
    ranges
}) => {
    const data = {
        apps,
        ranges
    };
    return http.post(statsApiPath, data);
};

export const formatRangesForGet = (ranges) => {
    if (!ranges?.length) {
        return [];
    }

    if (ranges.length === 1) {
        const first = ranges[0];
        const firstMax = +first.max;

        // Return First Step & infinity Step [X, Infinity]
        return [{ min: +first.min, max: firstMax }, { min: +first.max + MIN_STEP_JUMP, max: -1 }];
    }

    /** More then one step,
     *  the first step must be in the range of [0, X] where X >=0 */
    const formattedRanges = ranges.reduce((acc, val, index) => {
        const max = +val.max;
        if (index === 0) {
            acc[index] = { min: 0, max };
            return acc;
        }
        acc[index] = { min: +val.min + MIN_STEP_JUMP, max };
        return acc;
    }, []);

    /** Return formatted steps & Infinity
     * for example [{min:0, max: 1}, {min: 1.5, max: 2}, {min: 2, max: -1}]  */
    return [...formattedRanges,
        { min: +formattedRanges[formattedRanges.length - 1].max + MIN_STEP_JUMP, max: -1 }];
};

export const formatCVMapResponse = (response) => response.map((value, index) => {
    if (index === 0) {
        return {
            ...value,
            min: 0,
            max: value.max
        };
    }
    return {
        ...value,
        min: response[index - 1].max
    };
});

export const roundValueToNearestStep = (value, step = MIN_STEP_JUMP) => {
    if (!value || value === 0) {
        return value;
    }
    const inv = 1.0 / step;
    return Math.round(value * inv) / inv;
};
